export class Swagger {
    swagger?;
    info: Info;
    paths?;
    definitions?;
}

export class Info {
    version?;
    title?;
    description?;
    termsOfService?;
}
